/**
 * Ghana Regions and Locations Data
 * 
 * This file contains all 16 regions of Ghana and their associated locations.
 * Used for registration forms and location selection throughout the application.
 */

// All 16 regions of Ghana
export const ghanaRegions = [
  'Greater Accra', 
  'Ashanti', 
  'Western', 
  'Central', 
  'Eastern', 
  'Volta', 
  'Northern', 
  'Upper East', 
  'Upper West', 
  'Bono', 
  'Bono East', 
  'Ahafo',
  'Western North',
  'Oti',
  'North East',
  'Savannah'
];

// Locations mapped by region name
export const ghanaLocationsByRegion = {
  'Greater Accra': [
    'Accra', 
    'Tema', 
    'Madina', 
    'Adenta', 
    'Dansoman', 
    'Kokomlemle', 
    'Legon', 
    'Spintex', 
    'East Legon', 
    'Labone', 
    'Osu', 
    'Cantonments'
  ],
  'Ashanti': [
    'Kumasi', 
    'Obuasi', 
    'Mampong', 
    'Ejisu', 
    'Konongo', 
    'Bekwai', 
    'Asante Mampong', 
    'Juaso', 
    'Agogo', 
    'Effiduase'
  ],
  'Western': [
    'Takoradi', 
    'Sekondi', 
    'Tarkwa', 
    'Axim', 
    'Prestea', 
    'Bogoso', 
    'Huni Valley', 
    'Elubo', 
    'Half Assini'
  ],
  'Central': [
    'Cape Coast', 
    'Winneba', 
    'Mankessim', 
    'Saltpond', 
    'Swedru', 
    'Kasoa', 
    'Agona Swedru', 
    'Elmina', 
    'Dunkwa'
  ],
  'Eastern': [
    'Koforidua', 
    'Nkawkaw', 
    'Mpraeso', 
    'Aburi', 
    'Somanya', 
    'Akim Oda', 
    'Suhum', 
    'Nsawam', 
    'Asamankese'
  ],
  'Volta': [
    'Ho', 
    'Hohoe', 
    'Keta', 
    'Aflao', 
    'Kpando', 
    'Jasikan', 
    'Nkwanta', 
    'Denu', 
    'Akatsi'
  ],
  'Northern': [
    'Tamale', 
    'Yendi', 
    'Bimbilla', 
    'Salaga', 
    'Damongo', 
    'Savelugu', 
    'Walewale', 
    'Buipe', 
    'Sawla'
  ],
  'Upper East': [
    'Bolgatanga', 
    'Bawku', 
    'Navrongo', 
    'Zuarungu', 
    'Bongo', 
    'Paga', 
    'Sandema', 
    'Fumbisi'
  ],
  'Upper West': [
    'Wa', 
    'Tumu', 
    'Lawra', 
    'Jirapa', 
    'Nadowli', 
    'Funsi', 
    'Hamile', 
    'Gwollu'
  ],
  'Bono': [
    'Sunyani', 
    'Berekum', 
    'Dormaa Ahenkro', 
    'Wenchi', 
    'Nkoranza', 
    'Jaman North', 
    'Jaman South', 
    'Tain'
  ],
  'Bono East': [
    'Techiman', 
    'Atebubu', 
    'Nkoranza', 
    'Kintampo', 
    'Prang', 
    'Yeji', 
    'Kwame Danso', 
    'Jema'
  ],
  'Ahafo': [
    'Goaso', 
    'Hwidiem', 
    'Kenyasi', 
    'Duayaw Nkwanta', 
    'Mim', 
    'Bechem', 
    'Kukuom', 
    'Acherensua'
  ],
  'Western North': [
    'Wiawso', 
    'Enchi', 
    'Bibiani', 
    'Sefwi Wiawso', 
    'Juaboso', 
    'Adabokrom', 
    'Asawinso', 
    'Bekwai'
  ],
  'Oti': [
    'Dambai', 
    'Jasikan', 
    'Kete Krachi', 
    'Kadjebi', 
    'Nkwanta', 
    'Krachi East', 
    'Krachi West', 
    'Nkwanta South'
  ],
  'North East': [
    'Nalerigu', 
    'Walewale', 
    'Gambaga', 
    'Bunkpurugu', 
    'Yagaba', 
    'Chereponi', 
    'Wulugu'
  ],
  'Savannah': [
    'Damongo', 
    'Bole', 
    'Sawla', 
    'Larabanga', 
    'Buipe', 
    'Yapei', 
    'Daboya', 
    'Mole'
  ]
};

// Default export for convenience
export default {
  regions: ghanaRegions,
  locations: ghanaLocationsByRegion
};
